import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { AlertsProvider, DialogsProvider } from '@theneatcompany/nui'
import { IntlProvider } from 'react-intl'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReCaptchaProvider } from 'next-recaptcha-v3'

import messages from '@/translations/messages'
import flattenMessages from '@/utils/intl'
import IntercomProvider from '@/components/Providers/IntercomProvider'
import SignUpProvider from '@/components/Providers/SignUpProvider'
import { GOOGLE_SIGN_IN_ID, RECAPTCHA_V3_SITE_KEY } from '@/config'
import { useNonce } from '@/utils/nonce'

const DEFAULT_LOCALE = 'en-US'

export default function Providers({ children }) {
  const queryClient = useMemo(() => new QueryClient(), [])
  const nonce = useNonce()

  return (
    <ReCaptchaProvider
      reCaptchaKey={RECAPTCHA_V3_SITE_KEY}
      nonce={nonce}
    >
      <IntlProvider
        formats={{
          number: {
            usd: { style: 'currency', currency: 'USD' },
          },
        }}
        locale={DEFAULT_LOCALE}
        messages={flattenMessages(messages[DEFAULT_LOCALE])}
      >
        <QueryClientProvider client={queryClient}>
          <AlertsProvider>
            <DialogsProvider>
              <IntercomProvider>
                <SignUpProvider>
                  <GoogleOAuthProvider clientId={GOOGLE_SIGN_IN_ID}>
                    {children}
                  </GoogleOAuthProvider>
                </SignUpProvider>
              </IntercomProvider>
            </DialogsProvider>
          </AlertsProvider>
        </QueryClientProvider>

      </IntlProvider>
    </ReCaptchaProvider>
  )
}

Providers.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
}
